/**
 * Poesias de Antônio Varella (Varella Sambista).
 * O texto foi transcrito dos PDFs originais enviados pelo autor, com
 * ortografia e acentuação normalizadas — as palavras e a ordem dos versos
 * foram mantidas. O PDF original de cada poesia fica linkado no card.
 */
const poems = [
  {
    id: 'renascenca-do-destino',
    title: 'A Renascença do Destino',
    epigraph: 'Sentimento de Varella inesquecível — que um dia um menino poeta escreveu',
    pdf: '/poesia.pdf',
    text: `A vida da gente é igual a um barco
Que vai navegando por este mundo afora,
De polo a polo, eu vou vivendo.
A alegria vai chegando dentro do coração
Deste menino poeta,
Que muitas vezes nada precisa
Para ser feliz. As razões
E a renascença do destino
Nos põem a encontrar a sabedoria dos homens
Entre sonhos e fascinações
Que a vida vai oferecendo.

Cada um de nós são palavras verdadeiras
Destinadas... Que um dia um menino poeta escreveu.
Quem é este menino poeta?
Este menino poeta sou eu.`
  },
  {
    id: 'minha-maneira-de-ser',
    title: 'Essa é a Minha Maneira de Ser',
    epigraph: 'Sentimento de Varella inesquecível — que um dia um menino poeta escreveu',
    pdf: '/poesia-minha-maneira-de-ser.pdf',
    isNew: true,
    text: `Eu sei que sou
Um camarada
Cheio de defeitos
Que já queria ter o seu amor.
Eu sei que sempre chego
Nas horas erradas
E pouco sei falar de amor.
Não sei como parar pra mudar.
Um dia, quem sabe,
Posso encontrar uma pessoa
Que me compreenda
E reconheça essa minha
Maneira de ser.

Sou tímido,
Que às vezes
Me perco nos meus sentimentos.
Sempre chego na hora errada
Quando digo: estou apaixonado.
É o que sinto,
Quero desabafar com alguém.

Sentimentos meus,
Meus sentimentos.
É essa a minha maneira de ser.
Você que tantas vezes, um dia,
Escutou isto dos meus lábios:
Essa canção de amor,
Essa paixão por uma flor
Que não quis me compreender.
São palavras carinhosas e românticas,
É o que sinto por você.
Você que tantas vezes também
Me viu chorando!
Tudo por causa desse amor.
Será porque sou pobre, sou nobre, de pouca cultura,
Não tenho o direito de gostar de alguém?!`
  },
  {
    id: 'duas-criancinhas',
    title: 'Duas Criancinhas Bobinhas sem Destino',
    epigraph: 'Sentimento de Varella inesquecível — que um dia um menino poeta escreveu',
    pdf: '/poesia-duas-criancinhas.pdf',
    isNew: true,
    text: `É... Nós parecemos que no mundo não há lugar para nós vivermos,
Para nos amarmos
E criar tudo aquilo que nós gostamos.
Nós parecemos duas criancinhas bobinhas, sem destino.
Será que você não entende que nós
Precisamos plantar? Para que possamos
Ver o futuro de perto.
Você talvez não queira acreditar.
Olha! Posso lhe fazer uma pergunta:
Por que acha tão difícil amar a vida?
Você não deveria fugir da realidade,
Deveria acreditar um pouquinho mais
Em si próprio.
O homem ama é para ser amado.

Já pensou se eu fosse o mar e chegasse,
Tornando toda a minha angústia sobre ele?
Você iria sentir como é triste amarmos dessa maneira,
Gastarmos desse jeito. Nós podemos?
Então vamos voar juntos, plantarmos juntos
E termos mais amor com a vida.
Nós precisamos amar, amar
E vivermos a vida.`
  },
  {
    id: 'vivendo-e-aprendendo',
    title: 'Vivendo e Aprendendo',
    epigraph: 'Sentimento de Varella inesquecível',
    pdf: '/poesia-vivendo-e-aprendendo.pdf',
    text: `Quando a gente ama alguém de verdade,
Faria qualquer coisa para não destruir
Aquele amor que sentimos.
É verdade franca e correta,
É muito importante saber
Que são coisas determinadas e sensíveis.
Realmente, amar é importante,
Sofrer e desiludir também.
Somos um navio que parte pelo mundo,
Somos humanos, não desumanos.

Quer ser alegre para não ser triste?
Quero viver a vida como ela é!
Todos sabemos que a vida pesa muito,
Somos fortes como o sol que nasce nas montanhas.

Que tu serás? Serás uma imagem
Ou uma figura desumana?
Corta essa cara, nós precisamos
Conversar um pouco e dialogar com a vida.
Todos nós temos os nossos problemas,
Ninguém é santo, veja,
Nem se levarmos o conhecimento à guerra,
Nada vai adiantar se tornarmos
Uma pessoa rude e cheia de rancor.
Não é assim que devemos ser.
Precisamos sempre lembrar
Tudo que fizemos de bom!
É vivendo e aprendendo.`
  }
];

export default poems;
